import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConvertibility = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "convertibility",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17539",
		"data-name": "Group 17539",
		transform: "translate(2 2.393)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13030",
				"data-name": "Path 13030",
				d: "M14.948,11.1V9h-2.1",
				transform: "translate(-6.281 -5.393)",
				fill: "none",
				stroke: "#666",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13031",
				"data-name": "Path 13031",
				d: "M19,5.667,19.667,5",
				transform: "translate(-8.333 -4.06)",
				fill: "none",
				stroke: "#666",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13032",
				"data-name": "Path 13032",
				d: "M9,5H4.333A1.333,1.333,0,0,0,3,6.333v8a1.333,1.333,0,0,0,1.333,1.333H13a1.333,1.333,0,0,0,1.333-1.333V11",
				transform: "translate(-3 -4.06)",
				fill: "none",
				stroke: "#666",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13033",
				"data-name": "Path 13033",
				d: "M20,9h.94",
				transform: "translate(-8.667 -5.393)",
				fill: "none",
				stroke: "#666",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13034",
				"data-name": "Path 13034",
				d: "M16,4.53V3.59",
				transform: "translate(-7.333 -3.59)",
				fill: "none",
				stroke: "#666",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13035",
				"data-name": "Path 13035",
				d: "M3,12.5c5.333,1.2,7.833-2.247,7.833-2.247",
				transform: "translate(-3 -5.81)",
				fill: "none",
				stroke: "#666",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_13036",
		"data-name": "Path 13036",
		d: "M0,0H16V16H0Z",
		fill: "none"
	})]
});
export default SvgConvertibility;
